import { useCallback } from 'react'
import { User } from 'store/user'
import { useUserStore } from './useUserStore'

export const useDeleteUser = (user: User): (() => Promise<void>) => {
    const store = useUserStore()

    return useCallback(() => store.deleteUser(user.userId), [user, store])
}
